import { useCallback, useEffect, useMemo } from 'react';
import { elevioPublicGqlClient } from '../../components/shared/knowledgeBaseLinkPreview/api';
import { useElevioIntegration } from '../../elevioIntegrationProvider';
import { useAsyncCallState } from './useAsyncCallState';
export function useElevioQuery({ query, variables, companyId, }) {
    const { elevioIntegration } = useElevioIntegration();
    const { data, error, isLoading, setData, setError, setIsLoading } = useAsyncCallState();
    const triggerFetch = useCallback(() => {
        if (!query)
            return;
        if (!variables)
            return;
        if (!(elevioIntegration === null || elevioIntegration === void 0 ? void 0 : elevioIntegration.companyId) && !companyId)
            return;
        setIsLoading(true);
        return elevioPublicGqlClient
            .request(query, variables, {
            'company-uid': companyId !== null && companyId !== void 0 ? companyId : ((elevioIntegration === null || elevioIntegration === void 0 ? void 0 : elevioIntegration.companyId) || ''),
        })
            .then(setData)
            .catch(setError)
            .finally(() => setIsLoading(false));
    }, [
        companyId,
        elevioIntegration === null || elevioIntegration === void 0 ? void 0 : elevioIntegration.companyId,
        query,
        variables,
        setData,
        setError,
        setIsLoading,
    ]);
    useEffect(() => {
        triggerFetch();
    }, [triggerFetch]);
    return useMemo(() => ({ data, error, isLoading, triggerFetch }), [data, error, isLoading, triggerFetch]);
}
